import { render, staticRenderFns } from "./OrgsInput.vue?vue&type=template&id=56c8b858&scoped=true&"
import script from "./OrgsInput.vue?vue&type=script&lang=js&"
export * from "./OrgsInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c8b858",
  null
  
)

export default component.exports